import {isValueFile, isValueNullish, isValueNumericEnum, isValueString, isValuePlainObject} from '@colonist/validation'
import {SDKRequest} from '../../../../../../shared/DiscordActivityTypes.ts'
import {ColonistMembershipType, ColonistOneTimePurchaseType} from '@colonist/types'
import {ColonistCoinType} from '../../../../../../shared/store/ColonistCoinProduct.ts'

export class SDKRequestValidateAction {
    readonly type: SDKRequest
    readonly data: any
    isValid: boolean

    constructor(type: SDKRequest, data: any) {
        this.type = type
        this.data = data
        this.validateAction()
    }

    private validateAction() {
        this.isValid = this.validateData() ?? false
        if(this.isValid) return

        throw new Error('Invalid SDK Request')
    }

    validateData(): boolean {
        switch(this.type) {
            case SDKRequest.PurchaseMembership:
                return isValueNumericEnum(this.data, ColonistMembershipType)
            case SDKRequest.PurchaseGift:
                return isValueNumericEnum(this.data, ColonistOneTimePurchaseType)
            case SDKRequest.PurchaseCoins:
                return isValueNumericEnum(this.data, ColonistCoinType)
            case SDKRequest.InviteFriends:
                return isValueNullish(this.data)
            case SDKRequest.ShareMoment:
                return isValueFile(this.data)
            case SDKRequest.OpenExternalLink:
                return isValueString(this.data)
            case SDKRequest.ShareActivityLink:
                return isValuePlainObject(this.data)
        }
    }
}
